import {ApiSortOrder} from '@/api/meta/odata';
import {getContacts} from '@/api/module/contact';
import {ApiContact} from '@/model/Contact';
import {defineStore} from 'pinia';
import {ref} from 'vue';


export const useContactSelectStore = defineStore('contactSelect', () => {
  const loading = ref(true);
  const initialized = ref(false);
  const error = ref<Error | null>(null);
  const data = ref<ApiContact[]>([]);

  async function fetch(KundenNr: number) {
    loading.value = true;
    try {
      [data.value] = await getContacts({
        KundenNr: KundenNr,
        Fulltext$Fulltext: {
          words: [''],
          fields: [],
        },
        Ausgeschieden: false,
      }, [['Nachname', ApiSortOrder.Asc]]);
    } catch (e) {
      error.value = e as Error;
    } finally {
      loading.value = false;
      initialized.value = true;
    }
  }
  /*
  function shortToFull(kurz: string): string {
    const result = data.value.find((contact) => contact === kurz);
    return result ? result.Name : '';
  }
  */
  return {
    loading,
    error,
    data,
    initialized,
    fetch,
    // shortToFull,
  };
});
